import {
  ComponentPropsWithoutRef,
  FC,
} from 'react';
import { SegmentedControl } from '@mantine/core';
import { changeLanguage } from '../i18n';

import './LanguageSelector.css'
import { useTranslation } from 'react-i18next';


const data = [
  {
    label: 'En',
    value: 'en',
  },
  {
    label: 'Ру',
    value: 'ru',
  },
];

export const LanguageSelector: FC = () => {
  const { i18n } = useTranslation()

  const selectedLang = data.find((x) => x.value === i18n.language)

  return (
    <SegmentedControl
      value={selectedLang?.value}
      data={data}
      onChange={(x) => {
        changeLanguage(x as string)
      }}
    />
  )
}
